const enum FlowCommentType {
  UserComment = 0,
  StepTaskCreated = 1,
  StepTaskDone = 2,
  StepTaskApproved = 3,
  StepTaskRejected = 4
}
export default FlowCommentType;
